module.exports = __webpack_public_path__ + "static/media/bumeran.2cbf09d1.svg";